import { StyleSheet } from 'aphrodite';
import constants from '../../../constants/styles';
let {
  HIGHLIGHT_COLOR,
  ACCORDION_CHILD_BG_COLOR,
  ACCORDION_CHILD_HOVER_BG_COLOR,
  ACCORDION_BORDER_COLOR
} = constants;

let styles = {
  zone: {
    display: 'flex',
    backgroundColor: ACCORDION_CHILD_BG_COLOR,
    borderTop: `1px solid ${ACCORDION_BORDER_COLOR}`,
    padding: '20px 30px 20px 80px',
    ':hover': {
      backgroundColor: ACCORDION_CHILD_HOVER_BG_COLOR
    },
    ':last-child': {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10
    }
  },
  field: {
    display: 'flex',
    color: HIGHLIGHT_COLOR,
    fontSize: '0.8em',
    textTransform: 'uppercase',
    fontWeight: 800,
    paddingLeft: 15,
    margin: 'auto 0'
  },
  name: {
    width: 200
  },
  address: {
    marginLeft: 15
  },
  icon: {
    cursor: 'pointer',
    fontSize: 12,
    color: HIGHLIGHT_COLOR,
    fontWeight: 'bold',
    margin: 'auto 0'
  },
  iconHidden: {
    visibility: 'hidden'
  },
  options: {
    margin: 'auto 0 auto auto'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/accordionzone/AccordionZone.styles.js